/* eslint-disable no-shadow */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { GlobalContext } from 'providers/GlobalProvider';
import RunScreening from './Components/RunScreening';
import SchedulePeriodicComp from './Components/SchedulePeriodicComp';
import ScreeningHistory from './Components/ScreeningHistory';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import { enqueueSnackbar } from 'notistack';
import BiteDBAPI from 'api/BiteDBAPI';
import { IScreeningResultRow } from 'interfaces/IBiteDB';

interface DashboardProps {
  tabs?: string;
  screeningResults: IScreeningResultRow[];
}
const ScreeningInfo: React.FC<DashboardProps> = ({
  tabs,
  screeningResults,
}) => {
  const { cur_user } = useContext(GlobalContext);
  const history = useHistory();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedOptsType, setSelectedOptsType] = useState<string[]>([]);
  const [selectedItems, setSelectedItems] = useState<any[]>([]);
  const [databases, setDatabases] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [nrPeopleAndCompanies, setNrPeopleAndCompanies] = useState(0);
  const [nrProducts, setNrProducts] = useState(0);
  const [nrOfTotalItems, setNrOfTotalItems] = useState(0);

  const [tab, setTab] = useState<string>(tabs ? tabs : 'Run Screening');

  const fetchDatabases = useCallback(async () => {
    try {
      setIsLoading(true);
      const selected_team_id = cur_user?.selected_team?.id;
      if (!selected_team_id) {
        enqueueSnackbar('Please select a team', { variant: 'error' });
        return;
      }
      const response = await BiteDBAPI.getDatabasesByGroupId(selected_team_id);
      if (response?.success) {
        const nrPeople = response.result.filter(
          (db: any) => db.type === 'people & companies',
        );
        const nrProducts = response.result.filter(
          (db: any) => db.type === 'products',
        );
        setNrPeopleAndCompanies(nrPeople.length);

        setNrProducts(nrProducts.length);
        setDatabases(response.result);
      } else {
        enqueueSnackbar(`Error fetching databases: ${response?.result}`, {
          variant: 'error',
        });
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  }, [cur_user?.selected_team?.id]);

  const handleTabSwitch = (type: string) => {
    switch (type) {
      case 'Run Screening':
        setTab('Run Screening');
        break;
      case 'Schedule':
        setTab('Schedule');
        break;
      case 'History':
        setTab('History');
        break;
      default:
        setTab('Run Screening');
    }
  };
  const suppliersData = [
    {
      name: 'Acme Electronics',
      description: 'Electronic component supplier',
      category: 'Manufacturer',
      riskLevel: 'High',
      linkedProducts: 12,
    },
    {
      name: 'TechWorld Distribution',
      description: 'Global distributor of technology products',
      category: 'Distributor',
      riskLevel: 'Medium',
      linkedProducts: 8,
    },
    {
      name: 'Silicon Valley Components',
      description: 'Semiconductor manufacturer',
      category: 'Manufacturer',
      riskLevel: 'Cleared',
      linkedProducts: 5,
    },
    {
      name: 'Global Circuit Solutions',
      description: 'Circuit board manufacturer',
      category: 'Manufacturer',
      riskLevel: 'Barred',
      linkedProducts: 3,
    },
    {
      name: 'Advanced Materials Inc.',
      description: 'Raw materials supplier',
      category: 'Supplier',
      riskLevel: 'No risk assessment',
      linkedProducts: null,
    },
    {
      name: 'European Tech Solutions',
      description: 'IT services and hardware',
      category: 'Service Provider',
      riskLevel: 'Cleared',
      linkedProducts: 6,
    },
    {
      name: 'Nordic Components Ltd',
      description: 'Electronic components from Scandinavia',
      category: 'Distributor',
      riskLevel: 'Medium',
      linkedProducts: 4,
    },
    {
      name: 'German Precision Mechanics',
      description: 'High-precision mechanical parts',
      category: 'Manufacturer',
      riskLevel: 'Cleared',
      linkedProducts: 2,
    },
    {
      name: 'French Circuit Designs',
      description: 'Custom circuit design and manufacturing',
      category: 'Service Provider',
      riskLevel: 'High',
      linkedProducts: 1,
    },
  ];

  useEffect(() => {
    fetchDatabases();
  }, [fetchDatabases]);

  return (
    <div className='team-content-container'>
      <div className='people-col'>
        <div className='team-content-header' style={{ gap: '10px' }}>
          <div className='team-content-search'>
            <div className='card-db-header'>
              <div className='card-db-icon'>
                {
                  <NotificationsActiveOutlinedIcon
                    sx={{ fontSize: 20, color: 'var(--Primary-400, #4895ef)' }}
                  />
                }
              </div>
              <div className='card-db-title'>{'Screening'}</div>
            </div>
          </div>
        </div>
        <div className='team-content-header'>
          <div className='team-content-search'>
            <span className='card-db-meta-span'>
              {' '}
              {
                'Screen your databases against potential risks and schedule periodic screenings.'
              }
            </span>
          </div>
        </div>
      </div>

      <div className='screening-tabs-container'>
        <div className='screening-tabs-inner'>
          <div
            className={`screening-tab-btn${
              tab === 'Run Screening' ? '-selected' : ''
            }`}
            onClick={() => handleTabSwitch('Run Screening')}
          >
            <div
              className={`screening-tab-btn-text${
                tab === 'Run Screening' ? '-selected' : ''
              }`}
            >
              {tab === 'Run Screening' ? (
                <NotificationsActiveOutlinedIcon
                  sx={{ fontSize: 20, color: 'var(--Primary-400, #4895ef)' }}
                />
              ) : (
                <NotificationsActiveOutlinedIcon sx={{ fontSize: 20 }} />
              )}
              Run Screening
            </div>
          </div>
          <div
            className={`screening-tab-btn${
              tab === 'Schedule' ? '-selected' : ''
            }`}
            onClick={() => handleTabSwitch('Schedule')}
          >
            <div
              className={`screening-tab-btn-text${
                tab === 'Schedule' ? '-selected' : ''
              }`}
            >
              {tab === 'Schedule' ? (
                <CalendarTodayOutlinedIcon
                  sx={{ fontSize: 20, color: 'var(--Primary-400, #4895ef)' }}
                />
              ) : (
                <CalendarTodayOutlinedIcon sx={{ fontSize: 20 }} />
              )}
              Schedule
            </div>
          </div>
          <div
            className={`screening-tab-btn${
              tab === 'History' ? '-selected' : ''
            }`}
            onClick={() => handleTabSwitch('History')}
          >
            <div
              className={`screening-tab-btn-text${
                tab === 'History' ? '-selected' : ''
              }`}
            >
              {tab === 'History' ? (
                <AccessTimeOutlinedIcon
                  sx={{ fontSize: 20, color: 'var(--Primary-400, #4895ef)' }}
                />
              ) : (
                <AccessTimeOutlinedIcon sx={{ fontSize: 20 }} />
              )}
              History
            </div>
          </div>
        </div>
      </div>

      {tab === 'Run Screening' && (
        <>
          <RunScreening
            databases={databases}
            isLoading={isLoading}
            screeningResults={screeningResults}
            onViewAllHistory={() => handleTabSwitch('History')}
          />
        </>
      )}
      {tab === 'Schedule' && (
        <SchedulePeriodicComp databases={databases} isLoading={isLoading} />
      )}
      {tab === 'History' && (
        <ScreeningHistory screeningResults={screeningResults} />
      )}
    </div>
  );
};

export default ScreeningInfo;
